export const getCategoryPath = (categoryName) => {
  return `/${categoryName.toLowerCase().replace(/\s+/g, '-')}`;
};

export const navigateToCategory = (navigate, categoryName, state = {}) => {
  navigate(`/${categoryName.toLowerCase().replace(/\s+/g, '-')}`, { state });
};